import { InjectionToken } from '@angular/core';

export const SyncToken = new InjectionToken('SyncToken');
